"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TouchArea = exports.IconWrapper = exports.Link = exports.MinusIcon = exports.PlusIcon = exports.ListContainer = exports.MenuItemSecond = exports.MenuItemFirst = exports.MenuItemContainer = exports.Container = exports.ItemLevel = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const Theme_1 = require("../../../../../Theme");
const Typography_1 = __importDefault(require("../../../../UI/Typography"));
const PlusBigIcon_1 = require("../../../../../assets/svg-components/PlusBigIcon");
const MinusBigIcon_1 = require("../../../../../assets/svg-components/MinusBigIcon");
var ItemLevel;
(function (ItemLevel) {
    ItemLevel["FIRST"] = "first";
    ItemLevel["SECOND"] = "second";
    ItemLevel["THIRD"] = "third";
})(ItemLevel = exports.ItemLevel || (exports.ItemLevel = {}));
const getBackgroundColor = (type) => {
    switch (type) {
        case ItemLevel.FIRST:
            return Theme_1.theme.palette.LIGHT_GRAY_20;
        case ItemLevel.SECOND:
            return Theme_1.theme.palette.LIGHT_GRAY_10;
        case ItemLevel.THIRD:
            return Theme_1.theme.palette.BW_100;
        default:
            return Theme_1.theme.palette.LIGHT_GRAY_30;
    }
};
exports.Container = styled_components_1.default.div `
  border-bottom: 1px solid ${props => props.theme.palette.LIGHT_GRAY_40};
`;
exports.MenuItemContainer = styled_components_1.default.div `
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  background-color: ${props => (props.isOpen ? getBackgroundColor(props.type) : props.theme.palette.BW_100)};
  padding: ${props => props.theme.spacing.s2}px 0 ${props => props.theme.spacing.s2}px
    ${props => props.theme.spacing.s4}px;
  min-height: ${props => props.theme.constants.mobileMenu.itemContainerMinHeight}px;
`;
exports.MenuItemFirst = (0, styled_components_1.default)(Typography_1.default) `
  margin: 0;
  font-weight: ${props => props.isOpen && props.theme.typography.weight.medium};
`;
exports.MenuItemSecond = (0, styled_components_1.default)(Typography_1.default) `
  margin: 0 ${props => props.theme.spacing.s4}px 0 0;
  font-weight: ${props => props.isOpen && props.theme.typography.weight.medium};
  padding-left: ${props => props.theme.spacing.s4}px;
`;
exports.ListContainer = styled_components_1.default.div `
  margin: ${props => props.theme.spacing.m1}px 0 ${props => props.theme.spacing.m1}px
    ${props => props.theme.spacing.l4}px;
  margin-left: ${props => props.theme.spacing.l4}px;
`;
exports.PlusIcon = (0, styled_components_1.default)(PlusBigIcon_1.PlusBigIcon) `
  > line {
    stroke: ${props => props.theme.palette.LIGHT_BLACK};
  }
`;
exports.MinusIcon = (0, styled_components_1.default)(MinusBigIcon_1.MinusBigIcon) `
  > line {
    stroke: ${props => props.theme.palette.LIGHT_BLACK};
  }
`;
exports.Link = styled_components_1.default.a `
  color: ${props => props.theme.palette.BW_0};
  font-size: inherit;
  text-decoration: none;

  :active,
  :visited {
    color: ${props => props.theme.palette.BW_0};
  }
`;
exports.IconWrapper = styled_components_1.default.div `
  display: flex;
  align-items: center;
  justify-content: center;
  width: ${props => props.theme.constants.mobileMenu.iconWrapper}px;
  height: ${props => props.theme.constants.mobileMenu.iconWrapper}px;
  border: 1px solid ${props => props.theme.palette.LIGHT_GRAY_40};
  border-radius: ${props => props.theme.constants.borderRadius.xss}px;
`;
exports.TouchArea = styled_components_1.default.div `
  display: flex;
  align-items: center;
  justify-content: center;
  height: ${props => props.theme.constants.mobileMenu.touchArea}px;
  width: ${props => props.theme.constants.mobileMenu.touchArea}px;
  margin-right: ${props => props.theme.constants.mobileMenu.specialSpacing}px;
`;
exports.default = {
    Container: exports.Container,
    MenuItemContainer: exports.MenuItemContainer,
    MenuItemFirst: exports.MenuItemFirst,
    MenuItemSecond: exports.MenuItemSecond,
    PlusIcon: exports.PlusIcon,
    MinusIcon: exports.MinusIcon,
    IconWrapper: exports.IconWrapper,
    TouchArea: exports.TouchArea,
    Link: exports.Link
};
